/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { getEntities as getPharmacySuppliers } from 'app/entities/pharmacy-suppliers/pharmacy-suppliers.reducer';
import { getEntities as getPharmacists } from 'app/entities/pharmacist/pharmacist.reducer';
import { VendorReturnStatus } from 'app/shared/model/enumerations/vendor-return-status.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-return-bill.reducer';

export const PharmacyReturnBillUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const pharmacySuppliers = useAppSelector(state => state.pharmacySuppliers.entities);
  const pharmacists = useAppSelector(state => state.pharmacist.entities);
  const pharmacyReturnBillEntity = useAppSelector(state => state.pharmacyReturnBill.entity);
  const loading = useAppSelector(state => state.pharmacyReturnBill.loading);
  const updating = useAppSelector(state => state.pharmacyReturnBill.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyReturnBill.updateSuccess);
  const vendorReturnStatusValues = Object.keys(VendorReturnStatus);

  const handleClose = () => {
    navigate(`/pharmacy-return-bill${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacies({}));
    dispatch(getPharmacySuppliers({}));
    dispatch(getPharmacists({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.billDate !== undefined && typeof values.billDate !== 'number') {
      values.billDate = Number(values.billDate);
    }
    if (values.claimAmount !== undefined && typeof values.claimAmount !== 'number') {
      values.claimAmount = Number(values.claimAmount);
    }
    if (values.totalCost !== undefined && typeof values.totalCost !== 'number') {
      values.totalCost = Number(values.totalCost);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.cgst !== undefined && typeof values.cgst !== 'number') {
      values.cgst = Number(values.cgst);
    }
    if (values.sgst !== undefined && typeof values.sgst !== 'number') {
      values.sgst = Number(values.sgst);
    }
    if (values.printCount !== undefined && typeof values.printCount !== 'number') {
      values.printCount = Number(values.printCount);
    }

    const entity = {
      ...pharmacyReturnBillEntity,
      ...values,
      pharmacy: pharmacies.find(it => it.id.toString() === values.pharmacy?.toString()),
      supplier: pharmacySuppliers.find(it => it.id.toString() === values.supplier?.toString()),
      processedBy: pharmacists.find(it => it.id.toString() === values.processedBy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          status: 'NONE',
          ...pharmacyReturnBillEntity,
          pharmacy: pharmacyReturnBillEntity?.pharmacy?.id,
          supplier: pharmacyReturnBillEntity?.supplier?.id,
          processedBy: pharmacyReturnBillEntity?.processedBy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyReturnBill.home.createOrEditLabel" data-cy="PharmacyReturnBillCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyReturnBill.home.createOrEditLabel">
              Create or edit a PharmacyReturnBill
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-return-bill-id"
                  label={translate('tinyMedicRestApp.pharmacyReturnBill.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBill.billNumber')}
                id="pharmacy-return-bill-billNumber"
                name="billNumber"
                data-cy="billNumber"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBill.billDate')}
                id="pharmacy-return-bill-billDate"
                name="billDate"
                data-cy="billDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBill.claimAmount')}
                id="pharmacy-return-bill-claimAmount"
                name="claimAmount"
                data-cy="claimAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBill.totalCost')}
                id="pharmacy-return-bill-totalCost"
                name="totalCost"
                data-cy="totalCost"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBill.discount')}
                id="pharmacy-return-bill-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBill.active')}
                id="pharmacy-return-bill-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBill.cursor')}
                id="pharmacy-return-bill-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBill.timestampentry')}
                id="pharmacy-return-bill-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBill.microSec')}
                id="pharmacy-return-bill-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBill.lastUpdated')}
                id="pharmacy-return-bill-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBill.cgst')}
                id="pharmacy-return-bill-cgst"
                name="cgst"
                data-cy="cgst"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBill.sgst')}
                id="pharmacy-return-bill-sgst"
                name="sgst"
                data-cy="sgst"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBill.status')}
                id="pharmacy-return-bill-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {vendorReturnStatusValues.map(vendorReturnStatus => (
                  <option value={vendorReturnStatus} key={vendorReturnStatus}>
                    {translate(`tinyMedicRestApp.VendorReturnStatus.${vendorReturnStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBill.printed')}
                id="pharmacy-return-bill-printed"
                name="printed"
                data-cy="printed"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBill.printCount')}
                id="pharmacy-return-bill-printCount"
                name="printCount"
                data-cy="printCount"
                type="text"
              />
              <ValidatedField
                id="pharmacy-return-bill-pharmacy"
                name="pharmacy"
                data-cy="pharmacy"
                label={translate('tinyMedicRestApp.pharmacyReturnBill.pharmacy')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-return-bill-supplier"
                name="supplier"
                data-cy="supplier"
                label={translate('tinyMedicRestApp.pharmacyReturnBill.supplier')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacySuppliers
                  ? pharmacySuppliers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-return-bill-processedBy"
                name="processedBy"
                data-cy="processedBy"
                label={translate('tinyMedicRestApp.pharmacyReturnBill.processedBy')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacists
                  ? pharmacists.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-return-bill" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyReturnBillUpdate;
